class PrimerryHeader extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('.primerry-menu');
    this.openers = this.querySelectorAll('.primerry-header__shop-trigger, .primerry-header__mobile-menu');
    this.closeButton = this.querySelector('.primerry-menu__close');
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.open = () => {
      if (!this.dialog || this.dialog.open) return;
      // Horizon measures --header-group-height from its own header-component, which this
      // header replaces, so that value stays at its 60px fallback; measure our own bottom edge.
      const headerBottom = Math.round((this.closest('#header-group') || this).getBoundingClientRect().bottom);
      this.dialog.style.setProperty('--primerry-menu-top', `${Math.max(headerBottom, 0)}px`);
      this.dialog.showModal();
    };
    this.close = () => this.dialog?.close();
    this.onBackdrop = (event) => {
      if (event.target === this.dialog) this.close();
    };
    this.onTab = (event) => {
      const tab = event.currentTarget;
      this.tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
        const panel = this.querySelector(`#${item.getAttribute('aria-controls')}`);
        panel?.classList.toggle('is-active', active);
        if (panel) panel.hidden = !active;
      });
    };
    this.openers.forEach((opener) => opener.addEventListener('click', this.open));
    this.closeButton?.addEventListener('click', this.close);
    this.dialog?.addEventListener('click', this.onBackdrop);
    this.tabs.forEach((tab) => tab.addEventListener('click', this.onTab));
  }
  disconnectedCallback() {
    this.openers?.forEach((opener) => opener.removeEventListener('click', this.open));
    this.closeButton?.removeEventListener('click', this.close);
    this.dialog?.removeEventListener('click', this.onBackdrop);
    this.tabs?.forEach((tab) => tab.removeEventListener('click', this.onTab));
  }
}

if (!customElements.get('primerry-header')) customElements.define('primerry-header', PrimerryHeader);
